export default __webpack_public_path__ + "static/media/star.df660177.svg";